import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form"
export default class extends Controller {
  static values = { debounce: { type: Number, default: 200 } }

  disconnect() {
    clearTimeout(this.timeout);
  }

  submit() {
    this.element.requestSubmit();
  }

  debouncedSubmit() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.submit(), this.debounceValue);
  }
}
